import React from 'react'; 
import ReactDOM from 'react-dom/client'; 
import App from './App'; 
import './index.css';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// --- ANTI-GOOGLE-TRANSLATE-CRASH SCRIPT ---
if (typeof Node === 'function' && Node.prototype) {
  const originalRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function (child) {
    if (child.parentNode !== this) {
      if (console) {
        console.warn('Google Translate Crash Prevented: Cannot remove a child from a different parent');
      }
      return child;
    }
    return originalRemoveChild.apply(this, arguments);
  };

  const originalInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function (newNode, referenceNode) {
    if (referenceNode && referenceNode.parentNode !== this) {
      if (console) {
        console.warn('Google Translate Crash Prevented: Cannot insert before a reference node from a different parent');
      }
      return newNode;
    }
    return originalInsertBefore.apply(this, arguments);
  };
}
// ------------------------------------------



const root = ReactDOM.createRoot(document.getElementById('root')); 
root.render(<App />);

serviceWorkerRegistration.register();